import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Modal,
  Button,
  Skeleton,
  Grid,
} from "@mui/material";

const UserProfile = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  useEffect(() => {
    setTimeout(() => {
      fetch(`https://facerec.xdestudios.com/user?id=${id}`, {
        headers: new Headers({
          "ngrok-skip-browser-warning": "69420",
        }),
      })
        .then((res) => res.json())
        .then((data) => setUserData(data))
        .catch((err) => console.error("Error:", err));
    }, 2000);
  }, [id]);

  const handleDownload = async () => {
    try {
      const response = await fetch(currentImage, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        headers: { "Content-Type": "application/octet-stream" },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the file");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;

      const nameSplit = currentImage.split("/");
      const fileName = decodeURIComponent(nameSplit.pop());

      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.log("Error while downloading the image", error.message);
    }
  };

  return (
    <Box
      sx={{
        background: "linear-gradient(to bottom, rgb(40,29,68), black)",
        minHeight: "100vh",
        padding: 3,
      }}
    >
      {/* Header Section */}
      <Box
        sx={{
          maxWidth: "800px",
          margin: "0 auto",
          textAlign: "center",
          mb: 3,
        }}
      >
        {userData ? (
          <>
            <Typography
              variant="h4"
              sx={{ color: "white", mb: 1, fontWeight: 600 }}
            >
              {userData.name}'s Gallery
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{ color: "white", mb: 2, fontWeight: 100 }}
            >
              Phone: +91 {userData.phone}
            </Typography>
          </>
        ) : (
          <>
            <Skeleton
              variant="text"
              width={200}
              height={40}
              sx={{ bgcolor: "grey.700", margin: "auto" }}
            />
            <Skeleton
              variant="text"
              width={150}
              height={20}
              sx={{ bgcolor: "grey.700", margin: "auto", mb: 2 }}
            />
          </>
        )}

        <Paper
          elevation={3}
          sx={{
            background: "rgba(40,29,68,0.8)",
            backdropFilter: "blur(10px)",
            borderRadius: "16px",
            padding: 2,
            mb: 3,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: "white",
              fontWeight: "lighter",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Image Gallery
          </Typography>
        </Paper>
      </Box>

      {/* Responsive Image Grid */}
      <Box sx={{ maxWidth: "1200px", margin: "0 auto", px: 2 }}>
        <Grid container spacing={2}>
          {userData
            ? userData.links.map((link, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                  <Box
                    component="img"
                    src={link}
                    alt={`img ${index}`}
                    onClick={() => {
                      setCurrentImage(link);
                      setOpen(true);
                    }}
                    sx={{
                      width: "100%",
                      height: "auto",
                      borderRadius: 2,
                      cursor: "pointer",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  />
                </Grid>
              ))
            : [...Array(8)].map((_, index) => (
                <Grid item xs={6} sm={4} md={3} key={index}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={200}
                    sx={{ borderRadius: 2, bgcolor: "grey.700" }}
                  />
                </Grid>
              ))}
        </Grid>
      </Box>

      {/* Image Modal */}
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setCurrentImage("");
        }}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            backgroundColor: "rgba(40,29,68,0.9)",
            borderRadius: "16px",
            padding: 3,
            outline: "none",
            boxShadow: 24,
            textAlign: "center",
            maxWidth: "90%",
            maxHeight: "90%",
          }}
        >
          <img
            src={currentImage}
            alt="Preview"
            style={{
              width: "100%",
              maxHeight: "70vh",
              borderRadius: "8px",
              objectFit: "contain",
              marginBottom: "16px",
            }}
          />
          <Button
            variant="contained"
            sx={{
              backgroundColor: "rgba(40,29,68,0.1)",
              border: "1px solid #ff6f61",
              color: "#ff6f61",
              mr: 1,
            }}
            onClick={() => window.open(currentImage, "_blank")}
          >
            View Full Size
          </Button>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#ff6f61",
              color: "rgba(40,29,68)",
            }}
            onClick={handleDownload}
          >
            Download
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default UserProfile;
